import React from 'react';
import { DndProvider } from 'react-dnd';
import { getPlatform } from 'util/user-agent-util';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';

const DragDropProvider = ({ children }) => {
  const platform = getPlatform();
  const providerProps = {
    backend: !platform.ios ? HTML5Backend : TouchBackend,
    options: platform.ios ? { enableMouseEvents: true, enableHoverOutsideTarget: true } : {}
  };

  const w = window as any;
  // shttps://github.com/react-dnd/react-dnd/issues/3178
  if (w.__isReactDndBackendSetUp) {
    w.__isReactDndBackendSetUp = false;
  }
  return <DndProvider {...providerProps}>{children}</DndProvider>;
};

export const WithDragDrop = ({ children }) => {
  return <DragDropProvider>{children}</DragDropProvider>;
};
